/*
 * @Author: 刘小博
 * @Date: 2022-11-11 17:20:54
 * @LastEditTime: 2023-02-27 17:06:49
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\store\getters.js
 * 文件备注
 */
export default {
  init: (state) => state.data.init,
  innerHeight: (state) => state.data.innerHeight,
  regionList: (state) => state.data.regionList, //地区列表
  productList: (state) => state.data.productList, //产品列表
  productTreeCategoriesList: (state) => state.data.productTreeCategoriesList, //产品分类树形列表
  deptmentByAccountIdList: (state) => state.data.deptmentByAccountIdList, //当前登录人的部门列表
}
